<template>
	<div>
		<div class="container">

			<div class="handle-box-search">


				<el-row class="head-search">
					<el-col :span="24">
						<span class="title">角色名称:</span>
						<el-input v-model="search_data.name" placeholder="要搜索的角色名称" class="handle-input mr10" maxlength="30"
							style="width: 200px;" @keyup.enter.native="searchAdminRoleLists">
						</el-input>
					</el-col>


				</el-row>





				<el-button type="primary" icon="el-icon-search" @click="searchAdminRoleLists">搜索</el-button>
				<el-button @click="addRoleSubmitShow = !addRoleSubmitShow">添加</el-button>
				<el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
			</div>

			<el-table :data="result_data.data" class="table" ref="multipleTable" header-cell-class-name="table-header"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" align="center" prop="admin_role_code"></el-table-column>

				<el-table-column label="角色名称">
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="bottom">
							<p>角色编码: {{ scope.row.admin_role_code }}</p>
							<div slot="reference">
								<el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.name }}</el-tag>
							</div>
						</el-popover>
					</template>
				</el-table-column>

			

				<el-table-column label="描述" prop="remarks"> </el-table-column>

				<el-table-column label="添加时间" prop="time.YmdHis"> </el-table-column>

				<el-table-column label="操作" width="180" align="center">
					<template slot-scope="scope">



						<el-dropdown split-button trigger="click" type="primary"
							@click="editRoleSubmitShow = !editRoleSubmitShow; editRole_data = scope.row.admin_role_code">
							编辑


							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="setNav(scope.row.admin_role_code)">设置导航</el-dropdown-item>
							</el-dropdown-menu>



						</el-dropdown>



					</template>
				</el-table-column>
			</el-table>

			<el-button @click="deleteData" type="primary" icon="el-icon-delete" class="handle-del mr10"
				style="margin-top: 20px;">批量删除</el-button>

			<!-- 分页组件 -->
			<div class="pagination">
				<pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
			</div>

		</div>
		<!-- 添加的弹窗子组件 -->
		<addRoleSubmit :isShow="addRoleSubmitShow" @submit_ok_return="pages_function"></addRoleSubmit>

		<!-- 编辑的弹窗子组件 -->
		<editRoleSubmit :isShow="editRoleSubmitShow" :editRole_data="editRole_data" @submit_ok_return="pages_function">
		</editRoleSubmit>

		<!-- 设置导航组件 -->
		<setNav :isShow="setNav_show" :data="setNav_data" @submit_ok_return="pages_function"></setNav>
	</div>
</template>
<script>
	var _this;
	import addRoleSubmit from '../system/addRoleSubmit';
	import editRoleSubmit from '../system/editRoleSubmit';
	import setNav from '../system/setNav';


	export default {

		components: {

			addRoleSubmit,
			editRoleSubmit,
			setNav

		},
		data() {
			return {

				setNav_show: false,
				setNav_data: '',



				delRoleSubmit_data: {

					admin_role_code_array: [],

				},
				delRoleSubmit_rules: {

					admin_role_code_array: {
						placeholder: '权限模块',
						rules: {
							required: false,
							message: '权限模块代码数组(json)',
							regulation: 'special',
							rulesData: 'json_array'
						}
					}

				},
				checked: false,

				search_data: {
					page: 1,
					limit: 10,
					name: '',
				},

				result_data: [],

				search_rules: {
					page: {
						placeholder: '页码',
						rules: {
							required: false,
							message: '页码需要大于0',
							regulation: 'gt',
							rulesData: 0
						}
					},
					limit: {
						placeholder: '每页个数',
						rules: {
							required: true,
							message: '每页个数需在1-51之内',
							regulation: 'between',
							rulesData: [1, 51]
						}
					},
					name: {
						placeholder: '搜索的角色名称',
						rules: {
							required: false,
							message: '角色名称需在10汉字之内',
							regulation: 'elt_str',
							rulesData: 30
						}
					}
				},

				addRoleSubmitShow: false, //添加的diglog

				editRoleSubmitShow: false, //编辑的diglog

				editRole_data: ''
			};
		},

		//生命周期，建立
		created() {

			_this = this;

			//初始化显示列表
			_this.adminRoleLists();

		},
		methods: {



			setNav(code) {

				_this.setNav_show = !_this.setNav_show;
				_this.setNav_data = code;

			},




			searchAdminRoleLists() {
				_this.search_data.page = 1;
				_this.adminRoleLists();
			},
			handleSelectionChange(val) {
				var datalist = [];

				for (var i in val) {
					datalist.push(val[i].admin_role_code);
				}

				_this.delRoleSubmit_data.admin_role_code_array = datalist;

			},

			// 批量删除
			deleteData() {

				if (_this.delRoleSubmit_data.admin_role_code_array.length == 0) {

					_this.$message.warning('请至少勾选一条数据');

					return;
				}

				_this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

					confirmButtonText: '确定',

					cancelButtonText: '取消',

					type: 'warning',

				}).then(() => {

					_this.delRoleSubmit_data.admin_role_code_array = JSON.stringify(_this.delRoleSubmit_data
						.admin_role_code_array);

					_this.$post(
						"/system/delRoleSubmit",
						_this.delRoleSubmit_data,
						_this.delRoleSubmit_rules
					).then(res => {

						_this.pages_function(_this.search_data);

						this.$message({

							type: 'success',

							message: '删除成功!',

						});

					}).catch((err) => {

						this.$message({

							type: 'info',

							message: '已取消删除',

						});

					})

				}).catch(() => {

				});

			},
			// 编辑弹窗
			edit(e) {

				_this.dialogIsShow = !_this.dialogIsShow;

				_this.admin_role_code = e;

			},

			//翻页组件的回调
			pages_function(search_data) {

				//赋值
				_this.search_data = search_data;

				//初始化
				_this.adminRoleLists();

			},

			//搜索角色列表
			adminRoleLists() {

				_this.$post(
					"/system/adminRoleLists",
					_this.search_data,
					_this.search_rules
				).then(res => {

					_this.result_data = res;

				}).catch((err) => {

				})

			},

			refresh() {
				this.$router.go(0);
			}

		}
	};
</script>

<style scoped>
	.checkbox {
		position: absolute;
		margin-left: 21px;
		top: 20px;
	}

	.page {
		position: absolute;
		right: 0;

	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}



	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
</style>